import get from "lodash/get";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "Actions/AxiosInstance";
import { ErrorMessages } from "Constants";
import Payrollwidgetselector from "../../../../../../Component/Payrollwidget/selector";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
});

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: 0,
      allsalarycomponents: [],
      datareceived: false,
    };

    this.getallsalarycomponents = this.getallsalarycomponents.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onselect = this.onselect.bind(this);
  }

  componentDidMount() {
    this.getallsalarycomponents();
    this.props.onRef({
      onNext: this.onSave,
      onCancel: this.props.onCancel,
      onPrev: this.props.onPrevClick,
    });
  }

  getallsalarycomponents() {
    instance
      .post("payroll/getallsalarycomponent", {
        paidastypeids: [1, 2],
        componenttypeids: [1],
        mastertaxgroupids: [1],
        isstatutory: false,
        isextrapayment: false,
        isextradeduction: false,
      })
      .then((res) => {
        if (get(res, "data.result", []).length > 0) {
          let { fbpcomponent } = this.props.postData;
          fbpcomponent = fbpcomponent && fbpcomponent.map((x) => ({
            ...x,
            isselected: true,
          }));
          const data = get(res, "data.result", []).map((apiinstance) => {
            const thisobj = fbpcomponent && fbpcomponent.find(
              (currentinstance) => currentinstance.salarycomponentid == apiinstance.displayvalue,
            );
            if (thisobj) {
              return {
                lowerlimit: 0,
                upperlimit: 1000000,
                ...thisobj,
                ...apiinstance,
              };
            }
            return { ...apiinstance,
              lowerlimit: 0,
              upperlimit: 1000000,
              isselected: false };
          });

          // const isbasicpayobj = data.find((x) => x.mastercomponentid === 101);
          // if (!isbasicpayobj) {
          //   this.props.enqueueSnackbar(ErrorMessages.E1450, { variant: "error" });
          //   this.props.onCancel();
          //   return;
          // }
          const allcomp = [
            ...data.filter(
              (x) => !x.isbalancing && !(x.mastercomponentid === 101),
            ),
          ];

          this.setState(
            {
              allsalarycomponents: allcomp || [],
              datareceived: true,
            },
            () => {
              // const filtercomp = this.state.allsalarycomponents.filter(
              //   (comp) => comp.isselected,
              // );
              // const pd = this.props.postData;
              // pd.fbpcomponent = [...filtercomp];
              // this.props.updatePostData(pd);
            },
          );
        } else {
          this.props.enqueueSnackbar(
            "Please create at least one tax free component",
            { variant: "error" },
          );
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onselect(data) {
    if (this.props.editableKey) {
      const index = this.state.allsalarycomponents.findIndex(
        (x) => x.displayvalue == data.displayvalue,
      );
      const { allsalarycomponents } = this.state;
      let x = allsalarycomponents[index];
      x = {
        ...x,
        isselected:
          x.displayvalue == data.displayvalue ? !x.isselected : x.isselected,
        salarycomponentid: x.displayvalue || 0,
      };
      allsalarycomponents[index] = x;
      this.setState(
        {
          allsalarycomponents,
        },
        () => {
          const filtercomp = this.state.allsalarycomponents.filter(
            (comp) => comp.isselected,
          );
          const pd = this.props.postData;
          pd.fbpcomponent = [...filtercomp];
          this.props.updatePostData(pd);
        },
      );
    }
  }

  onSave() {
    const filtercomp = this.state.allsalarycomponents.filter(
      (comp) => comp.isselected,
    );
    if (filtercomp && filtercomp.length > 0) {
      this.props.onNextClick();
    } else {
      this.props.enqueueSnackbar("Please select at least one component", {
        variant: "error",
      });
    }
  }

  render() {
    return (
      <IntlProvider locale="en" messages={""}>
      <div
          className="stepper-scroller padding-top-0 width100"
          style={{ display: "grid" }}
      >
        <div className="salary-component-wrapper thin-scroll1">
          {this.state.allsalarycomponents && this.state.allsalarycomponents.map((data) => (
            <Payrollwidgetselector
              data={data}
              onselect={this.onselect}
              selection={true}
            />
          ))}
        </div>
      </div>
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(Component)));
